import { trackByEvent } from '../../../../tracking/services';
import { COMPONENT_TYPE } from '../../../../tracking/constant';
import { PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS, TVideoClose, TVideoInplay, TVideoPlay } from './index'

export const trackVideoStart = (videoId : string, videoName : string, language : string) => {
    try {
        const trackData : TVideoPlay = {
            component_name: videoName,
            component_id: videoId,
            component_type: PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_PLAY.component_type as COMPONENT_TYPE,
            eventCategory:'',
            language,
            country: '',
            video_action:PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_PLAY.video_action
        }
        trackByEvent<TVideoPlay>(PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_PLAY.event, trackData)
    } catch (error) {
        console.log('trackVideoStart error', error);
    }
}

export const trackVideoPause = (videoId : string, videoName : string, language : string) => {
    try {
        const trackData : TVideoPlay = {
            component_name: videoName,
            component_id: videoId,
            component_type: PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_PAUSE.component_type as COMPONENT_TYPE,
            eventCategory:'',
            language,
            country: '',
            video_action:PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_PAUSE.video_action
        }
        trackByEvent<TVideoPlay>(PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_PAUSE.event, trackData)
    } catch (error) {
        console.log('trackVideoPause error', error);
    }
}

export const trackVideoClose = (videoId : string, videoName : string, language : string) => {
    try {
        const trackData : TVideoPlay = {
            component_name: videoName,
            component_id: videoId,
            component_type: PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_CLOSE.component_type as COMPONENT_TYPE,
            eventCategory:'',
            language,
            country: '',
            video_action:PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_CLOSE.video_action
        }
        trackByEvent<TVideoClose>(PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_CLOSE.event, trackData)
    } catch (error) {
        console.log('trackVideoClose error', error);
    }
}

export const trackVideoInplay = (videoId : string, 
                                 videoName : string, 
                                 language : string, 
                                 currentVideoTime : number, 
                                 videoDuration : number,
                                 passedPercentages : Array<Number>) => {
    const trackPercentages = [25, 50, 75, 90]
   
    const percentage = Math.round(100 / (Math.floor(videoDuration) / Math.floor(currentVideoTime)))
    const targetPercentage = trackPercentages.reverse().find(tp => percentage >= tp && !passedPercentages.includes(tp))
    if (targetPercentage) {
        try {
            const trackData : TVideoPlay = {
                component_name: videoName,
                component_id: videoId,
                component_type: PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_INPLAY.component_type as COMPONENT_TYPE,
                eventCategory:'',
                language,
                country: '',
                video_action:`${targetPercentage}% view`
            }
            trackByEvent<TVideoInplay>(PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS.VIDEO_INPLAY.event, trackData)
            return [targetPercentage, ...trackPercentages.filter(tp => targetPercentage >= tp  )]
        } catch (error) {
            console.log('trackVideoInplay error', error);
        } 
    }
}